export default __webpack_public_path__ + "static/media/T13D.e43983de.png";